import styled from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const Panel = styled.div`
  background: var(--cco-surface);
  border: 1px solid var(--cco-line);
  border-radius: 14px;
  width: 100%;
  max-width: 460px;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--cco-line);
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: var(--cco-ink);
`;

export const Close = styled.button`
  background: transparent;
  border: 1px solid var(--cco-line);
  color: var(--cco-ink-mute);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  :hover {
    background: var(--cco-soft-surface);
    color: var(--cco-ink);
  }
`;

export const Body = styled.div`
  padding: 18px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: var(--cco-ink);
`;

export const Input = styled.input`
  width: ${(props) => (props.$small ? '110px' : '100%')};
  height: 40px;
  padding: 0 12px;
  border-radius: 9px;
  border: 1px solid var(--cco-line);
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  outline: none;
  transition: border-color 150ms, box-shadow 150ms;

  &:focus {
    border-color: var(--cco-blue);
    box-shadow: 0 0 0 2px var(--cco-blue-soft);
  }
  &::placeholder {
    color: var(--cco-ink-faint);
    font-weight: 500;
  }
`;

export const Hint = styled.span`
  font-size: 11px;
  color: var(--cco-ink-faint);
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid var(--cco-line);
  padding-top: 14px;
`;

export const GroupLabel = styled.span`
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--cco-ink-mute);
`;

export const MachineRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const MachineName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--cco-line);
`;

export const Secondary = styled.button`
  height: 38px;
  padding: 0 18px;
  border-radius: 9px;
  border: 1px solid var(--cco-line);
  background: transparent;
  color: var(--cco-ink-mute);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Primary = styled.button`
  height: 38px;
  padding: 0 22px;
  border-radius: 9px;
  border: none;
  background: var(--cco-blue);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  transition: filter 150ms;

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
